import React from 'react';
import Table from 'react-bootstrap/Table';
import { Link } from 'react-router-dom';
import * as ROUTES from '../../lib/routing/frontend';
import { niceDateFormatter } from '../../lib/helper/formatting';
import { patientConsultantNames } from '../../lib/helper/patientFilters';

/**
 * MED-921 - the patient index.
 *
 * Two rows with the same name and the same date of birth are two different people, and this
 * table shows both. That is not a bug to tidy up: 1,091 names in this register are shared by more
 * than one person, held as 2,319 records, and deciding which of those are really one person is
 * the merge queue's job in slice 4. Hiding one of them here would mean a member of staff working
 * on the wrong person's invoices with nothing to tell them so.
 *
 * The date of birth column is what makes them distinguishable, so it is never blank-able for
 * layout reasons - a patient without one says so.
 */
class PatientListTable extends React.Component {
  render() {
    const { patients } = this.props;

    return (
      <div>
        <Table striped hover responsive className="mb-0">
          <thead>
            <tr>
              <th>Last Name</th>
              <th>First Name</th>
              <th>Date of Birth</th>
              <th>Consultant(s)</th>
              <th className="text-right">Invoices</th>
              <th className="text-right">Action</th>
            </tr>
          </thead>
          <tbody>
            {patients.map((patient) => {
              const to = ROUTES.PATIENTS.SINGLE.replace(':id', patient.id);
              const consultants = patientConsultantNames(patient);

              return (
                <tr key={patient.id}>
                  <td>
                    <Link to={to} className="text-body">
                      {patient.lastName}
                    </Link>
                  </td>
                  {/* Absent rather than null when empty - API Platform omits null fields. */}
                  <td>{patient.firstName || <span className="text-muted">-</span>}</td>
                  <td>{patient.dateOfBirth ? niceDateFormatter(patient.dateOfBirth) : <span className="text-muted">Not held</span>}</td>
                  <td>{consultants.length > 0 ? consultants.join(', ') : <span className="text-muted">-</span>}</td>
                  <td className="text-right">{patient.invoiceCount}</td>
                  <td className="text-sm-left text-md-right">
                    <Link to={to} className="btn btn-sm btn-primary ml-2">
                      View
                    </Link>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </Table>
      </div>
    );
  }
}

export default PatientListTable;
